import { CarrierBillingAccountSchema } from "@redotech/redo-fulfillment-carrier-account-common/carrier-billing-accounts";
import * as z from "zod";

/** Name predates receiver billing; renaming it would break in-flight bundles. */
export const getThirdPartyBillingAccounts = {
  name: "getThirdPartyBillingAccounts" as const,
  input: z.null(),
  output: z.object({ accounts: z.array(CarrierBillingAccountSchema) }),
};
